import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Icon, Button, List, Col, Row, Checkbox, Spin } from "ant-design-vue";
import { MediaSlot } from "@/util/enum";
import { PDFViewerPageReferencesModel, ResourceService } from "@/services/resource";
import { MediaViewerLocale } from "@/locales/localeid";
import { fmtMsg, ServerExceptionCode } from "commonui";

@Component({
	components: { Icon, Button, List, Row, Col, Item: List.Item, Checkbox, Spin }
})
export default class MediaViewer extends Vue {
	@Prop() mediaTypeId?: MediaSlot;
	@Prop() mediaId?: string;
	@Prop() isPage?: boolean;
	@Prop({ default: true }) isShowAdditionalData?: boolean;

	public pages: PDFViewerPageReferencesModel = {
		pageImages: [],
		pageInitialUrl: "",
		totalPages: 0,
		isDeleted: false
	};
	public imgUrl: string = "";
	public loading: boolean = false;
	public isProcessing: boolean = false;
	public isDeleted: boolean = false;

	mounted() {
		this.getPdfImages();
	}

	async getPdfImages() {
		this.loading = true;

		if (this.mediaTypeId === MediaSlot.Thumbnail || this.mediaTypeId === MediaSlot.Image) {
			try {
				const imgUrl = this.isPage
					? await ResourceService.getDownloadPageUrl(this.mediaId as string)
					: await ResourceService.getDownloadMediaUrl(this.mediaId as string);
				if (imgUrl) {
					this.imgUrl = imgUrl;
				}
				this.loading = false;
			} catch (err) {
				if (err && err["error_code"] === ServerExceptionCode.NotFound) {
					this.isDeleted = true;
				}
				this.loading = false;
			}
		} else if (
			(this.mediaTypeId === MediaSlot.ViewingContent ||
				this.mediaTypeId == MediaSlot.TeacherManual ||
				this.mediaTypeId == MediaSlot.AudioBackground) &&
			this.mediaId
		) {
			const result = await ResourceService.getPdfImages(this.mediaId);

			if (result && result.pageImages && result.pageImages.length > 0) {
				this.isDeleted = false;
				this.pages.pageInitialUrl = result.pageInitialUrl;
				this.pages.pageImages = result.pageImages.map((x) => x);
			} else {
				this.isDeleted = result.isDeleted;
			}
			this.loading = false;
		}
	}

	onCheckboxChange(e, pageId) {
		this.$emit("isDirty", { isDirty: true });
		this.pages.pageImages.forEach((page) => {
			if (page.id === pageId) {
				page.teacherUseOnly = e.target.checked;
			}
		});
	}

	get isMediaAlternateContent() {
		if (this.mediaTypeId && this.mediaTypeId === MediaSlot.AlternateContent) {
			return true;
		}

		return false;
	}

	get mediaViewerLocale() {
		return MediaViewerLocale;
	}

	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	get processingMessage() {
		switch (this.mediaTypeId) {
			case MediaSlot.ViewingContent:
				return this.formatMessage(MediaViewerLocale.MediaViewerViewingContentProcessingText);
			case MediaSlot.TeacherManual:
				return this.formatMessage(MediaViewerLocale.MediaViewerTeacherManualProcessingText);
			case MediaSlot.AudioBackground:
				return this.formatMessage(MediaViewerLocale.MediaViewerAudioBackgroundProcessingText);
			default:
				return this.formatMessage(MediaViewerLocale.MediaViewerProcessingText);
		}
	}
}
